export default __webpack_public_path__ + "static/SmallBusiness-new-20b69a29b9fc10477642871021e98b85.jpg";